import { useTranslation } from '@/i18n'

export function PoulePlaceholderTab({
  title,
  body,
}: {
  title: string
  body: string
}) {
  const { t } = useTranslation()
  return (
    <section className="rounded-[1.35rem] border border-[#202427] bg-[#0a0d0f] p-5">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-surface-500">
        {t('Fase 1')}
      </p>
      <h2 className="mt-3 text-xl font-black tracking-tight text-white">{title}</h2>
      <p className="mt-2 max-w-2xl text-sm leading-6 text-surface-400">{body}</p>
    </section>
  )
}
